<div class="row text-center">
  <div class="col-12-md">
    <h3>{{ 'Sellers.Products.Congratulations' | translate }}!</h3>
    <p>
      {{ 'Sellers.Products.CashMessage1' | translate }}
      <span *ngIf="isCashTypeReceived">
        {{ 'Sellers.Products.CashMessage2' | translate: { voucher: data.voucher } }}
        <span style="text-decoration: underline;" class="fw-bold"
              (click)="copyToClipboard(data.referenceNumber)">{{ data.referenceNumber }}</span>
      </span>
    </p>
    <p>
      {{ 'Sellers.Products.CashMessage3' | translate: { provider: data.provider } }}
      <span *ngIf="isCashTypeReceived">{{ 'Sellers.Products.CashMessage4' | translate: { date: data.expiryDate } }}</span>
    </p>
  </div>
  <button mat-flat-button color="warn" mat-dialog-close style="margin: auto;">
    {{ 'Sellers.Products.Close' | translate }}
  </button>
</div>
